import React from 'react';
import { Grid, FormControlLabel, Checkbox, Typography } from '@mui/material';

const TabFive = ({ 
  leaveManagementData, 
  setLeaveManagementData, 
  onClickAll, 
  isEdit,
  workModelData,
  setWorkModelData,
  workFromHomeData,
  setWorkFromHomeData,}) => {
  return (
    <>
      <Grid container>
      <Grid item xs={12} sx={{ mt: 2 }}>
        <FormControlLabel
          id="skills-form-edit-all"
          control={
            <Checkbox
              id="skills-edit-all"
              checked={leaveManagementData.every((dash) => dash.value)}
              disabled={isEdit}
              onClick={(e) =>
                onClickAll(leaveManagementData, 'common', setLeaveManagementData, e)
              }
            />
          }
          label="All"
        />
      </Grid>
      {leaveManagementData.map((data, index) => {
        return (
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={isEdit}
                  checked={leaveManagementData[index]?.value}
                  onChange={(e) => {
                    let items = [...leaveManagementData];
                    let item = { ...items[index] };
                    item = {
                      name: data.name,
                      tab: data.tab,
                      value: !data.value
                    };
                    items[index] = item;
                    setLeaveManagementData(items);
                  }}
                />
              }
              label={data.name}
            />
          </Grid>
        );
      })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Work Model
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="work-model-form-all"
            control={
              <Checkbox
                id="work-model-all"
                disabled={isEdit}
                checked={workModelData.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(workModelData, 'common', setWorkModelData, e)
                }
              />
            }
            label="All"
          />
        </Grid>
        {workModelData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={workModelData[index]?.value}
                    onChange={(e) => {
                      let items = [...workModelData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setWorkModelData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Work From Home
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <FormControlLabel
            id="work-from-home-form-all"
            control={
              <Checkbox
                id="work-from-home-all"
                disabled={isEdit}
                checked={workFromHomeData.every((dash) => dash.value)}
                onClick={(e) =>
                  onClickAll(workFromHomeData, 'common', setWorkFromHomeData, e)
                }
              />
            }
            label="All"
          />
        </Grid>
        {workFromHomeData.map((data, index) => {
          return (
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={workFromHomeData[index]?.value}
                    onChange={(e) => {
                      let items = [...workFromHomeData];
                      let item = { ...items[index] };
                      item = {
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setWorkFromHomeData(items);
                    }}
                  />
                }
                label={data.name}
              />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default TabFive;
